

import { useState } from "react";
import Config from "../../Config";


import MsgNew from "./MsgNew";
import Sended from "./Sended";
import Received from "./Received";
import ChatList from "./ChatList";

 





function MsgView(props)
{

 
 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }

    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";


    if(props.mainView.viewSelected == "new") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "sended") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "received") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "chat_list") tab4 = tab4 + " selected";


    var subMenu = <div className="submenu">
    <div className={tab1} module="msg" view="new" id="" onClick={props.mainView.quickGo} >Nowa wiadomość</div>
    <div className={tab2} module="msg" view="sended" id="" onClick={props.mainView.quickGo} >Wysłane</div>
    <div className={tab3} module="msg" view="received" id="" onClick={props.mainView.quickGo} >Odebrane</div>
    <div className={tab4} module="msg" view="chat_list" id="" onClick={props.mainView.quickGo} >Kontakty</div>
 
    </div>

 


    if(props.mainView.viewSelected == 'new' || props.mainView.viewSelected == undefined )
    {
        document.title ="Nowa wiadomość / Korespondencja"; 
        return (
            <div className="econtent ">      
                {subMenu}                                                                                          
                  <MsgNew  userData={props.userData}  mainView={props.mainView}  />    
             </div>
        )
    }


    if(props.mainView.viewSelected == 'sended'   )
        {
            document.title ="Wysłane / Korespondencja"; 
            return (
                <div className="econtent ">  
                       {subMenu}                                                                                              
                      <Sended  userData={props.userData}  mainView={props.mainView}  />    
                 </div>
            )
        }


     if(props.mainView.viewSelected == 'received'   )
            {
                document.title ="Odebrane / Korespondencja"; 
                return (
                    <div className="econtent ">       
                          {subMenu}                                                                                         
                          <Received  userData={props.userData}  mainView={props.mainView}  />    
                     </div>
                )
            }
 

      if(props.mainView.viewSelected == 'chat_list'   )
                {
                    document.title ="Chat / Korespondencja"; 
                    return (
                        <div className="econtent ">  
                              {subMenu}                                                                                              
                              <ChatList  userData={props.userData}  mainView={props.mainView}  />    
                         </div>
                    )
                }            

    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
    
}

export default MsgView ;